export const MerchantSelectionViewReferenceCodeMessages = {
  label: {
    id: 'Pages.MerchantSelection.View.ReferenceCode.label',
    description: 'Merchant Selection Page Reference Code Label'
  }
}
